import React from "react";
import { Outlet } from "react-router-dom";
import styled from "styled-components";

//import shared components
import SliderSwitch from "../components/SliderSwitch";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import Sidebar from "../components/Sidebar";

import { dark, light } from "../styles/Theme.styled";

//shared layout component
const SharedLayout = ({
  sidebarIsOpen,
  setSidebarIsOpen,
  docNavIsOpen,
  setDocNavIsOpen,
  theme,
  setTheme,
}) => {
  const toggleTheme = () => {
    if (theme === dark) {
      setTheme(light);
      localStorage.setItem("localTheme", "true");
    } else {
      setTheme(dark);
      localStorage.setItem("localTheme", "false");
    }
  };
  return (
    <Wrapper>
      <Nav
        setSidebarIsOpen={setSidebarIsOpen}
        setDocNavIsOpen={setDocNavIsOpen}
        docNavIsOpen={docNavIsOpen}
        theme={theme}
      />
      <Sidebar
        sidebarIsOpen={sidebarIsOpen}
        setSidebarIsOpen={setSidebarIsOpen}
      />
      <SliderSwitch toggleTheme={toggleTheme} theme={theme} />
      <div className="content-wrapper">
        <Outlet />
      </div>

      <Footer className="footer" />
    </Wrapper>
  );
};

export default SharedLayout;

const Wrapper = styled.div`
  position: relative;
  min-height: 100vh;

  .content-wrapper {
    padding-bottom: 15vh;
  }
  .footer {
    position: absolute;
    bottom: 0;
  }
  button.toggle-theme {
    position: absolute;
  }
`;
